export default __webpack_public_path__ + "e57f6d821cd78445911cdce883e23fa5.jpg";